module.exports = __webpack_public_path__ + "img/50400.a8cfe705.jpg";